import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {WebPayNowAction} from 'src/api/cargo-c2c/types'

import {classes} from './Payment.styles'
import {PaymentButton} from './PaymentButton'
import {PaymentItemComponent} from './PaymentItemComponent'

type Props = {
  paymentAction: WebPayNowAction
}

function Payment({paymentAction}: Props): React.ReactElement {
  const {payment_button: button, payment_item: item, payment_url: url} = paymentAction

  return (
    <Grid alignItems="center" className={classes.root} direction="column" container item>
      <Grid className={classes.section} container item>
        <PaymentItemComponent item={item} />
      </Grid>
      <Grid container item>
        <PaymentButton item={button} url={url} />
      </Grid>
    </Grid>
  )
}

export default Payment
